<template>
    <div
            class="plans"
            :class="{'plans_mobile': $vuetify.breakpoint.xsOnly}"
    >
        <v-progress-linear
                v-if="loading"
                indeterminate
        ></v-progress-linear>
        <div
                v-if="((getItems.projects === undefined && getItems.others === undefined) || (getItems.projects.length === 0 && getItems.others.length === 0)) && !loading"
                class="d-flex justify-center"
        >{{ $t('msg.noRecords') }}</div>
        <div
                v-if="getItems.projects !== undefined && getItems.projects.length > 0 && !loading"
                class="plans__projects"
                :class="{
                    'plans__projects_mobile': $vuetify.breakpoint.smAndDown
                }"
        >
            <div
                    v-for="project in getItems.projects"
                    class="plans__project"
                    :style="{
                        'background-color': project.color
                    }"
            >
                <div class="d-flex">
                    <div v-if="add" class="plans__add"></div>
                    <div v-if="mark" class="plans__task-mark"></div>
                    <div v-if="time" class="plans__time"></div>
                    <div class="plans__project-name">{{ project.name }}</div>
                    <div v-if="remove" class="plans__delete"></div>
                </div>
                <div class="plans__tasks">
                    <div
                            v-for="task in project.tasks"
                            class="plans__task"
                    >
                        <div
                                v-if="add"
                                class="plans__add"
                        >
                            <v-btn
                                    small
                                    icon
                                    @click="$emit('click-arrow', {project, task})"
                                    elevation="0"
                            >
                                <v-icon size="20" color="primary">mdi-arrow-left-thick</v-icon>
                            </v-btn>
                        </div>
                        <div
                                v-if="mark"
                                class="plans__task-mark"
                        >
                            <check-mark
                                    v-model="task.is_done"
                                    :action-change-true="markActionTrue"
                                    :action-change-false="markActionFalse"
                                    :custom-payload="markCustomPayload"
                                    :id="task.id"
                            ></check-mark>
                        </div>
                        <div
                                v-if="time" class="plans__time"
                        >{{ task.start }} - {{ task.end }}</div>
                        <div
                                class="plans__task-name"
                                :class="{'plans__task-name_link': itemAsLink}"
                                @click="$emit('click-item', task)"
                        >
                            <div
                                    v-if="!!task.task_id || (showProject && !!task.project_id)"
                                    class="d-flex"
                            >
                                <div v-if="showProject && !!task.project_id" class="plans__task-item">
                                    <v-icon
                                            size="16"
                                            class="plans__icon"
                                    >mdi-target</v-icon>
                                    <span
                                            class="plans__task-item-name"
                                    >{{ task.project.name }}</span>
                                </div>
                                <div v-if="!!task.task_id" class="plans__task-item">
                                    <v-icon
                                            v-if="taskIcon"
                                            size="16"
                                            class="plans__icon"
                                            :class="{
                                                'plans__task-done': task.is_done
                                            }"
                                    >mdi-checkbox-marked-circle-outline</v-icon>
                                    <span
                                            :class="{
                                                'plans__task-item-name': taskIcon
                                            }"
                                    >{{ task.task.full_name ? task.task.full_name : task.task.name }} <to-date :value="task.task.day_done"></to-date></span>
                                </div>
                                <div v-if="!!task.note_id" class="plans__task-item">
                                    <v-icon
                                            size="16"
                                            class="plans__icon"
                                    >mdi-note-text-outline</v-icon>
                                    <span class="plans__task-item-name">{{ task.note.name }}</span>
                                </div>
                            </div>
                            <div class="plans__name-and-tag">
                                <span v-if="!!task.name">{{ task.name }}</span>
                                <span v-if="!!task.tag && task.tag.length > 0" class="plans__tag">
                                  <tags v-model="task.tag"></tags>
                                </span>
                            </div>
                        </div>
                        <div
                                v-if="remove"
                                class="plans__remove"
                        >
                            <v-btn
                                    small
                                    icon
                                    @click="$emit('click-delete', task.id)"
                                    elevation="0"
                            >
                                <v-icon size="20" color="red">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
                v-if="getItems.projects.length > 0 && getItems.others.length > 0 && !loading"
                class="plans__hr"
        ></div>
        <div
                v-if="getItems.others !== undefined && getItems.others.length > 0 && !loading"
                class="plans__tasks plans__tasks_without-project"
                :class="{'mt-4': getItems.projects.length > 0 && getItems.others.length > 0}"
        >
            <div
                    v-for="task in getItems.others"
                    class="plans__task"
            >
                <div
                        v-if="add"
                        class="plans__add"
                >
                    <v-btn
                            small
                            icon
                            @click="$emit('click-arrow', {task})"
                            elevation="0"
                    >
                        <v-icon size="20" color="primary">mdi-arrow-left-thick</v-icon>
                    </v-btn>
                </div>
                <div v-if="mark" class="plans__task-mark">
                    <check-mark
                            v-model="task.is_done"
                            :action-change-true="markActionTrue"
                            :action-change-false="markActionFalse"
                            :custom-payload="markCustomPayload"
                            :id="task.id"
                    ></check-mark>
                </div>
                <div
                        class="plans__task-name"
                        :class="{'plans__task-name_link': itemAsLink}"
                        @click="$emit('click-item', task)"
                >
                    <div
                            v-if="!!task.task_id || !!task.note_id || (showProject && !!task.project_id)"
                            class="d-flex"
                    >
                        <div v-if="showProject && !!task.project_id" class="plans__task-item">
                            <v-icon
                                    size="16"
                                    class="plans__icon"
                            >mdi-target</v-icon>
                            <span
                                    class="plans__task-item-name"
                            >{{ task.project.name }}</span>
                        </div>
                        <div v-if="!!task.task_id" class="plans__task-item">
                            <v-icon
                                    v-if="taskIcon"
                                    size="16"
                                    class="plans__icon"
                            >mdi-checkbox-marked-circle-outline</v-icon>
                            <span
                                    :class="{
                                                'plans__task-item-name': taskIcon
                                            }"
                            >{{ task.task.name }}</span>
                        </div>
                        <div v-if="!!task.note_id" class="plans__task-item">
                            <v-icon
                                    size="16"
                                    class="plans__icon"
                            >mdi-note-text-outline</v-icon>
                            <span class="plans__task-item-name">{{ task.note.name }}</span>
                        </div>
                    </div>
                    <div class="plans__name-and-tag">
                        <span v-if="!!task.name">{{ task.name }}</span>
                        <span v-if="!!task.tag && task.tag.length > 0" class="plans__tag">
                          <tags v-model="task.tag"></tags>
                        </span>
                    </div>
                </div>
                <div
                        v-if="remove"
                        class="plans__remove"
                >
                    <v-btn
                            small
                            icon
                            @click="$emit('click-delete', task.id)"
                            elevation="0"
                    >
                        <v-icon size="20" color="red">mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CheckMark from "../../ui/CheckMark";
    import Tags from "@/components/ui/Tags";
    import ToDate from "@/components/ui/ToDate";

    export default {
        components: {CheckMark, Tags, ToDate},
        props: {
            items: Array|Object,
            mark: {type: Boolean, default: true},
            add: {type: Boolean, default: false},
            remove: {type: Boolean, default: false},
            taskIcon: {type: Boolean, default: false},
            itemAsLink: {type: Boolean, default: false},
            time: {type: Boolean, default: false},
            showProject: {type: Boolean, default: false},
            type: {type: String, default: 'plans'},
            selectedItems: {type: Array, default: () => []},
            markCustomPayload: {type: Function, default: null},
            markActionTrue: {type: String},
            markActionFalse: {type: String},
            loading: {type: Boolean, defatul: false}
        },
        computed: {
            getItems() {

                let projects = [];
                let others = [];

                if (this.type === 'plans') {

                    if (this.items !== undefined && this.items !== null) {

                        this.items.forEach((item, key) => {

                            if (!!item.project_id) {

                                if (this.selectedItems.indexOf(item.id) > -1) {
                                    return;
                                }

                                let keyProject = projects.map(v => v.id).indexOf(item.project_id);

                                if (keyProject === -1) {
                                    keyProject = projects.push({
                                        id: item.project_id,
                                        name: item.project.name,
                                        tasks: [],
                                        color: item.project.color
                                    }) - 1;
                                }

                                projects[keyProject].tasks.push(item);

                            } else {

                                if (this.selectedItems.indexOf(item.id) > -1) {
                                    return;
                                }

                                others.push(item);
                            }
                        });
                    }

                } else if (this.type === 'projects') {

                    if (this.items !== undefined && this.items !== null) {

                        this.items.forEach(project => {

                            let tasks = [];

                            project.tasks.forEach(task => {

                                if (this.selectedItems.indexOf(task.id) > -1) {
                                    return;
                                }

                                tasks.push({
                                    task_id: task.id,
                                    task: {
                                        name: task.name,
                                        note_id: task.note_id
                                    }
                                });

                                if (task.sub_tasks !== undefined && task.sub_tasks !== null) {
                                    task.sub_tasks.forEach(subTask => {

                                        if (this.selectedItems.indexOf(subTask.id) > -1) {
                                            return;
                                        }

                                        tasks.push({
                                            task_id: subTask.id,
                                            task: {
                                                name: task.name + ' > ' + subTask.name,
                                                note_id: subTask.note_id
                                            }
                                        });
                                    });
                                }
                            });

                            if (tasks.length === 0) {
                                return;
                            }

                            projects.push({
                                id: project.id,
                                name: project.name,
                                color: project.color,
                                tasks
                            });
                        });
                    }

                } else if (this.type === 'report') {

                    let project = {
                        id: null,
                        name: null,
                        tasks: []
                    };

                    this.items.report.forEach(item => {
                        if (item.id === null) return;
                        project.tasks.push(item);
                    });

                    if (project.tasks.length > 0) {
                        projects.push(project);
                    }

                    this.items.plan.forEach(item => {
                        others.push(item);
                    });
                }

                return {
                    projects,
                    others
                }
            }
        }
    }
</script>

<style lang="scss">
    .plans {
        &.plans_mobile {
            .plans__task-mark {
                width: 38px;
                min-width: 38px;
            }
            .plans__task-name {
                padding: 5px 0;
            }
        }
    }
    .plans__projects {
        //max-height: 350px;
        overflow-y: auto;
        overflow-x: hidden;

        &.plans__projects_mobile {
            max-height: inherit;

            .plans__task {
                margin-top: 7px;
                margin-bottom: 7px;
            }
            .plans__task-mark {
                width: 38px;
                min-width: 38px;
            }
            .plans__task-name {
                padding: 6px 0 5px 0;
            }
            .plans__add {
                .v-btn {
                    height: 29px;

                    .v-icon {
                        font-size: 28px !important;
                    }
                }
            }
        }
    }
    .plans__project {
        padding: 5px 8px;
    }
    .plans__project-name {
        font-size: 14px;
        color: #000000c4;
    }
    .plans__tasks {
        &.plans__tasks_without-project {
            padding: 0 8px;
        }
    }
    .plans__task {
        display: flex;
        align-items: flex-start;
        margin: 6px 0;
    }
    .plans__task-name {
        padding: 2px 0;
        user-select: none;

        &.plans__task-name_link {
            cursor: pointer;

            &:hover {
                color: #000;
            }
        }
    }
    .plans__task-mark {
        width: 30px;
        min-width: 30px;
    }
    .plans__task-item {
        line-height: 19px;
        margin-right: 10px;
        display: flex;
        align-items: flex-start;

        &:last-child {
            margin-right: 0;
        }
    }
    .plans__task-item-name {
        padding-left: 3px;
    }
    .plans__hr {
        height: 1px;
        background-color: #eee;
    }
    .plans__add {
        width: 30px;
        min-width: 30px;

        .v-btn {
            width: 23px;
            height: 23px;
        }
    }
    .plans__remove {
        .v-btn {
            width: 23px;
            height: 23px;
            margin-left: 5px;
        }
    }
    .plans__icon {
    }
    .plans__name-and-tag {
        &>span {
            margin-right: 5px;

            &:last-child {
                margin-right: 0;
            }
        }
    }
    .plans__tag {
        .v-chip {
            margin-right: 5px;

            &:last-child {
                margin-right: 0;
            }
        }
    }
    .plans__time {
        width: 82px;
        min-width: 82px;
        padding: 2px 0;
        color: #949494;
        white-space: nowrap;
    }
    .plans__task-done {
        color: #4caf50 !important;
    }
</style>